// extracted by mini-css-extract-plugin
module.exports = {"root":"DesktopCommsTable_root__KHm7A","tableRoot":"DesktopCommsTable_tableRoot__1Bp76","header":"DesktopCommsTable_header__2qTkQ"};